module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAMCAYAAAB4MH11AAAAAXNSR0IArs4c6QAAAFJJREFUOBFjYCAN8ACVgzBNAMjgw1BMdUtghv8HWgDCIIuoZgm64VS1BJfhVLGEkOEUWUKs4WRZQqrhJFlCruFEWUKp4XgtoZbhWC2htuEolgAAGjJ/daUapsYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Rectangle 4.png
// module id = YxKY
// module chunks = 23